<template>
  <div class="order-mask">
    <div
      class="c-content"
      v-if="isShowCreateOrder"
      :style="{ height: orderHeight + 'px' }"
    >
      <i class="close" @click.stop="closeOrder">
        <a-icon type="close" />
      </i>
      <div class="title">Create An order</div>
      <a-tabs v-model="activeKey">
        <a-tab-pane :key="1" tab="1.Add products">
          <div class="first" :style="{ height: orderHeight - 130 + 'px' }">
            <div class="add" @click.stop="addProduct_fun">
              <a-icon type="plus" />
              <span>Add from created products</span>
            </div>
            <div
              class="add-product"
              v-show="addProduct"
              :style="{ height: orderHeight - 300 + 'px' }"
            >
              <div
                class="a-list"
                v-for="(item, index) in createProductList"
                :key="index"
              >
                <div class="a-img">
                  <img :src="item.img" />
                </div>
                <div class="a-msg">
                  <h1>{{ item.title }}</h1>
                  <p>{{ item.name1 }}</p>
                  <p v-if="item.name2">{{ item.name2 }}</p>
                  <p v-if="item.name3">{{ item.name3 }}</p>
                  <!-- <p>Solid White S</p> -->
                </div>
                <div class="a-price">${{ item.retailPrice }}</div>
                <div class="a-count">
                  <a-input-number
                    id="inputNumber"
                    size="large"
                    v-model="item.num"
                    :min="1"
                    @change="onChange($event, index, item)"
                  />
                </div>
                <div class="a-price2">
                  ${{ item.changePrice | MoneyFormat }}
                </div>
                <div class="a-del" @click="delProduct(index)">
                  <img src="../assets/img/delete_icon.png" />
                </div>
              </div>
            </div>
            <div class="total-price">
              <span class="subtotal">Subtotal</span>
              <em>${{ totalMoney | MoneyFormat }}</em>
            </div>
            <div class="continue">
              <a-button type="primary" size="large" @click.stop="next(2)"
                >Continue</a-button
              >
            </div>
            <div
              class="me"
              :style="{ height: orderHeight - 70 + 'px' }"
              v-show="mask"
            >
              <div class="search">
                <a-icon type="arrow-left" @click.stop="retrunFirst" />
                <input
                  v-model="page.keyword"
                  type="text"
                  placeholder="Search created products"
                  @keyup.enter="searchProduct"
                />
              </div>
              <div
                :style="{ height: orderHeight - 200 + 'px' }"
                class="products infinite-list"
                v-infinite-scroll="load"
                v-show="choiceProduct"
              >
                <div class="titles">My Products</div>
                <div
                  class="p-list"
                  v-for="(item, index) in productList"
                  :key="index"
                  @click.stop="showChoiceProduct(item)"
                >
                  <div class="p-left">
                    <img :src="item.mainImageUrl" />
                  </div>
                  <div class="p-right">
                    <h1>{{ item.title }}</h1>
                    <p>{{ item.blankProductModel }}</p>
                    <p v-if="item.option2Num == 0">
                      {{ item.option1Num }} {{ item.option1Name }}
                    </p>
                    <p v-if="item.option3Num == 0">
                      {{ item.option1Num }} {{ item.option1Name }} ·
                      {{ item.option2Num }} {{ item.option2Name }}
                    </p>
                    <p v-else>
                      {{ item.option1Num }} {{ item.option1Name }} ·
                      {{ item.option2Num }} {{ item.option2Name }} ·
                      {{ item.option3Num }} {{ item.option3Name }}
                    </p>
                  </div>
                  <div class="p-icon">
                    <a-icon type="right" />
                  </div>
                </div>
              </div>
              <div
                class="sku"
                :style="{ height: orderHeight - 200 + 'px' }"
                v-show="choiceSku"
              >
                <div class="bread">
                  <a-breadcrumb>
                    <a-breadcrumb-item>Home</a-breadcrumb-item>
                    <a-breadcrumb-item>{{ productName }}</a-breadcrumb-item>
                    <a-breadcrumb-item v-if="this.breadcrumb.name1">{{
                      this.breadcrumb.name1
                    }}</a-breadcrumb-item>
                    <a-breadcrumb-item v-if="this.breadcrumb.name2">{{
                      this.breadcrumb.name2
                    }}</a-breadcrumb-item>
                    <a-breadcrumb-item v-if="this.breadcrumb.name3">{{
                      this.breadcrumb.name3
                    }}</a-breadcrumb-item>
                  </a-breadcrumb>
                </div>
                <div>
                  <div v-for="(item, index) in variantsList" :key="index">
                    <div
                      class="isSku1"
                      v-if="skuShowHide.isSku1 && item.productId == productId"
                    >
                      <div
                        class="sku-list"
                        @click.stop="showChoiceSku1(item, index)"
                      >
                        <div class="s-img">
                          <img :src="item.imageUrl" />
                        </div>
                        <div class="s-name">{{ item.introduce }}</div>
                        <div class="isAdd" v-if="item.isAdd">
                          <a-icon type="check" />
                          <span>Added</span>
                        </div>
                        <div class="s-price">
                          <a-icon type="caret-down" v-if="!item.retailPrice" />
                          <span v-if="item.retailPrice"
                            >${{ item.retailPrice }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="isSku2" v-if="skuShowHide.isSku2">
                    <div v-for="(item, index) in variantsList" :key="index">
                      <div
                        v-for="(item2, index2) in item.chidlrens"
                        :key="index2"
                      >
                        <div
                          class="sku-list"
                          v-if="
                            index == variantsListIndex.index1 &&
                              item.productId == productId
                          "
                          @click.stop="
                            showChoiceSku2(item, item2, index, index2)
                          "
                        >
                          <div class="s-img">
                            <img :src="item.imageUrl" />
                          </div>
                          <div class="s-name">{{ item2.introduce }}</div>
                          <div class="isAdd" v-if="item2.isAdd">
                            <a-icon type="check" />
                            <span>Added</span>
                          </div>
                          <div class="s-price">
                            <a-icon
                              type="caret-down"
                              v-if="!item2.retailPrice"
                            />
                            <span v-if="item2.retailPrice"
                              >${{ item2.retailPrice }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="isSku3" v-if="skuShowHide.isSku3">
                    <div v-for="(item, index) in variantsList" :key="index">
                      <div
                        v-for="(item2, index2) in item.chidlrens"
                        :key="index2"
                      >
                        <div
                          v-for="(item3, index3) in item2.chidlrens"
                          :key="index3"
                        >
                          <div
                            class="sku-list"
                            v-if="
                              index == variantsListIndex.index1 &&
                                index2 == variantsListIndex.index2 &&
                                item.productId == productId
                            "
                            @click.stop="
                              showChoiceSku3(item, item3, index, index2, index3)
                            "
                          >
                            <div class="s-img">
                              <img :src="item.imageUrl" />
                            </div>
                            <div class="s-name">{{ item3.introduce }}</div>
                            <div class="isAdd" v-if="item.isAdd">
                              <a-icon type="check" />
                              <span>Added</span>
                            </div>
                            <div class="s-price">
                              <a-icon
                                type="caret-down"
                                v-if="!item3.retailPrice"
                              />
                              <span v-if="item3.retailPrice"
                                >${{ item3.retailPrice }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane
          :key="2"
          tab="2.Add shipping information"
          :disabled="isDisableTab2"
        >
          <a-form-model
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            v-bind="layout"
            :style="{ height: orderHeight - 110 + 'px' }"
            class="scrolly"
          >
            <a-row type="flex">
              <a-col class="gutter-row" :span="12">
                <a-form-model-item
                  has-feedback
                  label="First name"
                  prop="firstName"
                >
                  <a-input
                    v-model="ruleForm.firstName"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <a-form-model-item
                  has-feedback
                  label="Last name"
                  prop="lastName"
                >
                  <a-input
                    v-model="ruleForm.lastName"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col class="gutter-row" :span="12">
                <a-form-model-item has-feedback label="Email (optional)">
                  <a-input
                    v-model="ruleForm.email"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <a-form-model-item has-feedback label="Phone" prop="phone">
                  <a-input
                    v-model="ruleForm.phone"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col class="gutter-row" :span="12">
                <a-form-model-item has-feedback label="Country" prop="country">
                  <a-select
                    v-model="ruleForm.country"
                    show-search
                    placeholder="Select a person"
                    option-filter-prop="children"
                    style="width: 100%"
                    :filter-option="filterOption"
                    @change="choiceCountrys"
                    autocomplete="off"
                  >
                    <!-- <a-select
                    v-model="ruleForm.country"
                    autocomplete="off"
                    @change="choiceCountrys"
                    >-->
                    <a-select-option
                      :value="item.id"
                      v-for="(item, index) in countrysList"
                      :key="index"
                      >{{ item.enName }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <a-form-model-item
                  has-feedback
                  label="State/ Province"
                  prop="state"
                >
                  <a-select
                    v-model="ruleForm.state"
                    autocomplete="off"
                    @change="choiceProvince"
                    v-show="provinceList.length > 0"
                  >
                    <a-select-option
                      :value="item.enName"
                      v-for="(item, index) in provinceList"
                      :key="index"
                      >{{ item.enName }}</a-select-option
                    >
                  </a-select>
                  <a-input
                    v-model="ruleForm.state"
                    v-show="provinceList.length == 0"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-model-item
              has-feedback
              label="Address"
              prop="address"
              :label-col="{ span: 4 }"
              :wrapperCol="{ span: 19 }"
            >
              <a-input
                v-model="ruleForm.address"
                type="text"
                autocomplete="off"
              />
            </a-form-model-item>
            <a-form-model-item
              has-feedback
              label="Address2"
              prop="address2"
              :label-col="{ span: 4 }"
              :wrapperCol="{ span: 19 }"
            >
              <a-input
                v-model="ruleForm.address2"
                type="text"
                autocomplete="off"
              />
            </a-form-model-item>
            <a-row type="flex">
              <a-col class="gutter-row" :span="12">
                <a-form-model-item has-feedback label="City" prop="city">
                  <a-input
                    v-model="ruleForm.city"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <a-form-model-item
                  has-feedback
                  label="Postal/ZIP Code"
                  prop="postal"
                >
                  <a-input
                    v-model="ruleForm.postal"
                    type="text"
                    autocomplete="off"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-model-item
              has-feedback
              label="note"
              prop="note"
              :label-col="{ span: 4 }"
              :wrapperCol="{ span: 19 }"
            >
              <a-input v-model="ruleForm.note" type="text" autocomplete="off" />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
              <a-button @click="back(2)">Back</a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click.stop="submitForm('ruleForm')"
                >Continue</a-button
              >
            </a-form-model-item>
          </a-form-model>
        </a-tab-pane>
        <a-tab-pane
          :key="3"
          tab="3.confirm order details"
          :disabled="isDisableTab3"
        >
          <div
            class="cons scrolly"
            :style="{ height: orderHeight - 110 + 'px' }"
          >
            <div class="add-product add-productH">
              <div
                class="a-list"
                v-for="(item, index) in createProductList"
                :key="index"
              >
                <div class="a-img">
                  <img :src="item.img" />
                </div>
                <div class="a-msg">
                  <h1>{{ item.title }}</h1>
                  <p>{{ item.name1 }}</p>
                  <p v-if="item.name2">{{ item.name2 }}</p>
                  <p v-if="item.name3">{{ item.name3 }}</p>
                  <!-- <p>Solid White S</p> -->
                </div>
                <div class="a-price">${{ item.retailPrice | MoneyFormat }}</div>
                <div class="a-num">{{ item.num }}</div>
                <div class="a-price2">
                  ${{ item.changePrice | MoneyFormat }}
                </div>
              </div>
            </div>
            <div class="order-msg">
              <div class="o-list">
                <p class="o-title">Shipping address</p>
                <p class="o-name">
                  {{ ruleForm.firstName }}{{ ruleForm.lastName }}
                </p>
                <p class="o-address">{{ ruleForm.address }}</p>
                <p class="o-address" v-if="ruleForm.address2">
                  {{ ruleForm.address2 }}
                </p>
                <p class="o-address2">
                  {{ ruleForm.city }}, {{ ruleForm.state }},
                  {{ ruleForm.postal }} {{ ruleForm.country }}
                </p>
                <p class="o-tel">{{ ruleForm.phone }}</p>
                <p class="o-tel">{{ ruleForm.email }}</p>
              </div>
              <div class="o-list">
                <p class="o-title">Shipping Methods</p>
                <div class="o-radio">
                  <a-radio-group v-model="value" @change="changeShopping">
                    <a-radio :value="1">Standard Delivery</a-radio>
                    <a-radio :value="2" v-if="priceMsg.express"
                      >Express Delivery</a-radio
                    >
                  </a-radio-group>
                </div>
              </div>
              <div class="o-list">
                <div class="o-total">
                  <span>Total costs</span>
                  <em v-if="value == 1">${{ standard.totalCosts }}</em>
                  <em v-if="value == 2">${{ express.totalCosts }}</em>
                </div>
                <div class="o-price">
                  <span>Production</span>
                  <em v-if="value == 1">${{ standard.production }}</em>
                  <em v-if="value == 2">${{ express.production }}</em>
                </div>
                <div class="o-price">
                  <span>Discount</span>
                  <em v-if="value == 1">${{ standard.discount }}</em>
                  <em v-if="value == 2">${{ express.discount }}</em>
                </div>
                <div class="o-price">
                  <span>Shipping</span>
                  <em v-if="value == 1">${{ standard.shipping }}</em>
                  <em v-if="value == 2">${{ express.shipping }}</em>
                </div>
                <div class="o-totalprice">
                  <span>Total</span>
                  <em v-if="value == 1">${{ standard.total }}</em>
                  <em v-if="value == 2">${{ express.total }}</em>
                </div>
              </div>
            </div>
            <div class="o-btn">
              <div>
                <a-button size="large" @click="back(3)">Back</a-button>
                <a-button size="large" @click.stop="create(1)"
                  >Save for later</a-button
                >
                <a-button size="large" type="primary" @click="goPay()"
                  >Proceed to payment</a-button
                >
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <onePay :isShow="outerVisible" :orderId="orderId" :payType="1"></onePay>
  </div>
</template>
<script>
//一次性支付
import onePay from "@/components/onePay";
import { productPage, customDetail } from "@/api/product";
import { calculate, createOrder } from "@/api/order";
import { countrys, provinces } from "@/api/public";
import { payMsg } from "@/api/pay";
export default {
  components: {
    onePay,
  },
  props: {
    isSamples: {
      type: Boolean,
    },
  },
  data() {
    return {
      orderHeight: 0,
      note: "", //备注
      orderId: [],
      isShowCreateOrder: true, //是否显示创建订单弹窗
      outerVisible: false, //是否显示添加银行卡弹窗
      addProduct: false, //第一步（选完之后）
      mask: true, //第一步（蒙版）
      choiceProduct: true, //第一步（第一步选择）
      choiceSku: false, //第一步（第二部选择）
      productList: [], //第一步，第一步的数据
      skuList1: [], //第一步，第二步的数据第一个规格的数据
      skuList2: [], //第一步，第二步的数据第二个规格的数据
      skuList3: [], //第一步，第二步的数据第三个规格的数据
      skuNum: 1, //有几个sku
      currSku: 1, //当前正在操作第几个sku
      breadcrumb: {
        //面包屑
        name1: "",
        name2: "",
        name3: "",
      },
      currNum: {
        index1: -1,
        index2: -1,
        index3: -1,
      },
      skuShowHide: {
        isSku1: false,
        isSku2: false,
        isSku3: false,
      },
      productName: "", //面包屑的产品名称
      productId: 0, //第一步选择的的产品ID
      countrysList: [], //国家列表
      countryId: 0, //国家ID
      provinceList: [], //省份列表
      isDisableTab2: true, //是否禁用第二个标签页
      isDisableTab3: true, //是否禁用第二个标签页
      activeKey: 1, //当选选中第几个tabs
      value: 1, //1小包，2快递
      num: 0,
      priceMsg: {}, //计算价格的信息
      express: {}, //快递-对应的价格
      standard: {}, //小包-对应的价格
      shoppingPrice: 0,
      currentNum: 0, //当前选择产品时的数量（第一步）
      page: {
        current: 0,
        size: 10,
        keyword: "", //关键字
        status: "",
      },
      ruleForm: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        address: "",
        address2: "",
        city: "",
        postal: "",
      },
      rules: {
        firstName: [
          {
            required: true,
            message: "First name is required",
          },
        ],
        lastName: [
          {
            required: true,
            message: "Last name is required",
          },
        ],
        email: [],
        phone: [
          {
            required: true,
            message: "Phone is required",
          },
        ],
        country: [
          {
            required: true,
            message: "Country is required",
          },
        ],
        state: [
          {
            required: true,
            message: "State is required",
          },
        ],
        address: [
          {
            required: true,
            message: "Address is required",
          },
          { max: 40, message: "Max length 40" },
        ],
        address2: [],
        city: [
          {
            required: true,
            message: "City is required",
          },
          { max: 40, message: "Max length 40" },
        ],
        postal: [
          {
            required: true,
            message: "ZIP code is required",
          },
        ],
        note: [{ max: 200, message: "Max length 200" }],
      },
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      },
      createProductList: [], //第一步，第三步的数据
      choiceProductId: [], //记录选择过哪些产品ID为了不重复访问customDetail接口
      variantsList: [], //展示给用户看的sku
      variantsListIndex: {
        //为了列表不显示重复数据
        index1: 1,
        index2: 2,
        index3: 3,
      },
      variantsIdList: [], //记录变体ID
      payInfo: "", //支付信息
    };
  },
  async mounted() {
    this.orderHeight = document.body.offsetHeight - 100;
    console.log("....." + this.orderHeight);
    {
      let { data } = await countrys();
      this.countrysList = data.countryInfoList;
    }
  },
  watch: {
    activeKey(val) {
      console.log(val);
      if (val == 3) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.isDisableTab3 = false;
            this.activeKey = 3;
            this.calculatePrice();
          } else {
            this.activeKey = 2;
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
  },
  computed: {
    totalMoney() {
      let num = 0;
      for (let i = 0; i < this.createProductList.length; i++) {
        num = num + this.createProductList[i]["changePrice"];
      }
      return num;
    },
  },
  methods: {
    //搜索国家
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //关闭订单
    closeOrder() {
      this.$parent.isOrder = false;
    },
    //选择物流
    changeShopping() {
      if (this.value == 2) {
        this.shoppingPrice = this.priceMsg.express.finalPrice;
      } else {
        this.shoppingPrice = this.priceMsg.standard.finalPrice;
      }
    },
    //第一步，第一步
    async showChoiceProduct(item) {
      this.productId = item.id;
      this.productName = item.blankProductModel;
      let { data } = await customDetail({ customProductId: item.id });
      const variants = data.variants;
      this.mask = true;
      this.choiceProduct = false;
      this.choiceSku = true;
      this.skuShowHide = {
        isSku1: true,
        isSku2: false,
        isSku3: false,
      };
      console.log(variants);
      let num = 1;
      if (variants[0].option3Value) {
        num = 3;
      } else if (variants[0].option2Value) {
        num = 2;
      } else {
        num = 1;
      }
      console.log("num...." + num);
      if (!this.choiceProductId.includes(item.id)) {
        this.choiceProductId.push(item.id);

        for (let i = 0; i < data.variantMap.length; i++) {
          data.variantMap[i].num = num;
          data.variantMap[i].productId = item.id;
          data.variantMap[i].imageUrl = item.mainImageUrl;
          data.variantMap[i].title = item.blankProductModel;
          //三个变体
          if (num == 3) {
            for (let j = 0; j < data.variantMap[i]["chidlrens"].length; j++) {
              for (
                let k = 0;
                k < data.variantMap[i]["chidlrens"][j]["chidlrens"].length;
                k++
              ) {
                for (let l = 0; l < variants.length; l++) {
                  if (
                    data.variantMap[i]["chidlrens"][j]["chidlrens"][k][
                      "variantIds"
                    ][0] == variants[l].id
                  ) {
                    data.variantMap[i]["chidlrens"][j]["chidlrens"][k][
                      "retailPrice"
                    ] = variants[l].costs;
                  }
                }
              }
            }
          } else if (num == 2) {
            for (let j = 0; j < data.variantMap[i]["chidlrens"].length; j++) {
              for (let l = 0; l < variants.length; l++) {
                if (
                  data.variantMap[i]["chidlrens"][j]["variantIds"][0] ==
                  variants[l].id
                ) {
                  data.variantMap[i]["chidlrens"][j]["retailPrice"] =
                    variants[l].costs;
                }
              }
            }
          } else if (num == 1) {
            for (let l = 0; l < variants.length; l++) {
              if (data.variantMap[i]["variantIds"][0] == variants[l].id) {
                data.variantMap[i]["retailPrice"] = variants[l].costs;
              }
            }
          }
          this.variantsList.push(data.variantMap[i]);
        }
      }
      console.log(this.variantsList);
    },
    //第一步，第二步(选第一个sku)
    async showChoiceSku1(item, index) {
      console.log(index);
      this.breadcrumb.name1 = item.optionValue;
      this.variantsListIndex = {
        index1: index,
        index2: 1,
        index3: 1,
      };
      if (item.num == 1) {
        if (this.variantsList[index].isAdd == true) {
          this.mask = false;
          this.addProduct = true;
          return;
        }
        const param = {};
        param.index1 = index;
        param.img = this.variantsList[index].imageUrl;
        param.name1 = this.variantsList[index].optionValue;
        param.title = this.variantsList[index].title;
        param.num = 1;
        param.retailPrice = this.variantsList[index].retailPrice;
        param.changePrice = this.variantsList[index].retailPrice;
        param.variantId = this.variantsList[index].variantIds[0];
        param.skuNum = this.variantsList[index]["num"];
        this.createProductList.push(param);
        const param2 = {};
        param2.variantId = this.variantsList[index].variantIds[0];
        param2.num = 1;
        this.variantsIdList.push(param2);
        this.variantsList[index].isAdd = true;
        this.mask = false;
        this.addProduct = true;
        this.skuShowHide = {
          isSku1: false,
          isSku2: false,
          isSku3: false,
        };
        this.$forceUpdate();
      } else {
        this.skuShowHide = {
          isSku1: false,
          isSku2: true,
          isSku3: false,
        };
      }
    },
    //第一步，第二步(选第二个sku)
    showChoiceSku2(item, item2, index, index2) {
      this.variantsListIndex = {
        index1: index,
        index2: index2,
        index3: 1,
      };
      this.breadcrumb.name2 = item2.optionValue; //面包屑名称
      if (item.num == 2) {
        if (this.variantsList[index].chidlrens[index2].isAdd == true) {
          this.mask = false;
          this.addProduct = true;
          return;
        }
        const param = {};
        param.index1 = index;
        param.index2 = index2;
        param.img = this.variantsList[index].imageUrl;
        param.name1 = this.variantsList[index].optionValue;
        param.name2 = this.variantsList[index].chidlrens[index2].optionValue;
        param.title = this.variantsList[index].title;
        param.num = 1;
        param.variantId = this.variantsList[index].chidlrens[
          index2
        ].variantIds[0]; //变体ID
        param.retailPrice = this.variantsList[index].chidlrens[
          index2
        ].retailPrice; //价格
        param.changePrice = this.variantsList[index].chidlrens[
          index2
        ].retailPrice; //价格
        param.skuNum = this.variantsList[index]["num"];
        this.createProductList.push(param);
        const param2 = {};
        param2.variantId = this.variantsList[index].chidlrens[
          index2
        ].variantIds[0];
        param2.num = 1;
        this.variantsIdList.push(param2);

        this.variantsList[index].isAdd = true;
        this.variantsList[index].chidlrens[index2].isAdd = true;
        this.mask = false;
        this.addProduct = true;
        this.variantsIdList;
        this.$forceUpdate();
      } else {
        this.skuShowHide = {
          isSku1: false,
          isSku2: false,
          isSku3: true,
        };
      }
    },
    //第一步，第二步(选第三个sku)
    showChoiceSku3(item, item2, index, index2, index3) {
      this.variantsListIndex = {
        index1: index,
        index2: index2,
        index3: index3,
      };
      if (
        this.variantsList[index].chidlrens[index2].chidlrens[index3].isAdd ==
        true
      ) {
        this.mask = false;
        this.addProduct = true;
        return;
      }
      const param = {};
      param.img = this.variantsList[index].imageUrl;
      param.index1 = index;
      param.index2 = index2;
      param.index3 = index3;
      param.name1 = this.variantsList[index].optionValue;
      param.name2 = this.variantsList[index].chidlrens[index2].optionValue;
      param.name3 = this.variantsList[index].chidlrens[index2].chidlrens[
        index3
      ].optionValue;
      param.title = this.variantsList[index].title;
      param.variantId = this.variantsList[index].chidlrens[index2].chidlrens[
        index3
      ].variantIds[0];
      param.num = 1;
      param.retailPrice = this.variantsList[index].chidlrens[index2].chidlrens[
        index3
      ].retailPrice;
      param.changePrice = this.variantsList[index].chidlrens[index2].chidlrens[
        index3
      ].retailPrice;
      param.skuNum = this.variantsList[index]["num"];
      this.createProductList.push(param);
      const param2 = {};
      param2.variantId = this.variantsList[index].chidlrens[index2].chidlrens[
        index3
      ].variantIds[0];
      param2.num = 1;
      this.variantsIdList.push(param2);
      this.variantsList[index].isAdd = true;
      this.variantsList[index].chidlrens[index2].isAdd = true;
      this.variantsList[index]["chidlrens"][index2].chidlrens[
        index3
      ].isAdd = true;
      this.$forceUpdate();

      this.mask = false;
      this.addProduct = true;
    },
    //第一步，删除产品
    delProduct(index) {
      console.log(this.createProductList);
      console.log(index);
      for (let i = 0; i < this.variantsIdList.length; i++) {
        if (
          this.variantsIdList[i].variantId ==
          this.createProductList[index]["variantId"]
        ) {
          this.variantsIdList.splice(i, 1);
        }
      }
      console.log(this.variantsIdList);
      if (this.createProductList[index]["skuNum"] == 3) {
        this.variantsList[this.createProductList[index].index1][
          "isAdd"
        ] = false;
        this.variantsList[this.createProductList[index].index1].chidlrens[
          this.createProductList[index].index2
        ]["isAdd"] = false;
        this.variantsList[this.createProductList[index].index1].chidlrens[
          this.createProductList[index].index2
        ].chidlrens[this.createProductList[index].index3]["isAdd"];
      } else if (this.createProductList[index]["skuNum"] == 2) {
        this.variantsList[this.createProductList[index].index1][
          "isAdd"
        ] = false;
        this.variantsList[this.createProductList[index].index1].chidlrens[
          this.createProductList[index].index2
        ]["isAdd"] = false;
      } else if (this.createProductList[index]["skuNum"] == 1) {
        this.variantsList[this.createProductList[index].index1][
          "isAdd"
        ] = false;
      }
      this.createProductList.splice(index, 1);
    },
    load() {
      this.page.current += 1;
      this.getProduct();
    },
    //获取产品列表
    async getProduct() {
      const _this = this;
      let { data } = await productPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
      });
      if (data.records.length > 0) {
        for (let i = 0; i < data.records.length; i++) {
          _this.productList.push(data.records[i]);
        }
      }
    },
    searchProduct() {
      this.productList = [];
      this.page.current = 1;
      this.getProduct();
    },
    //选择国家
    async choiceCountrys(e) {
      this.ruleForm.state = "";
      this.countryId = e;
      this.provinceList = [];
      let { data } = await provinces({ countryId: e });
      this.provinceList = data.provinceInfoList;
    },
    //选择省份
    async choiceProvince(e) {
      this.ruleForm.state = e;
    },
    //计算价格
    async calculatePrice() {
      let { data } = await calculate({
        countryId: this.countryId,
        itemList: this.variantsIdList,
      });
      this.priceMsg = data;
      this.express = data.express;
      this.standard = data.standard;
    },
    //刷新订单列表
    pullList() {
      this.$parent.orderList = [];
      this.$parent.paginations.current = 1;
      this.$parent.getOrderPage();
    },
    //关闭创建订单弹窗
    closeOrderMask() {
      this.$parent.isOrder = false;
    },
    //去一次性支付
    goPay() {
      this.create(2);
    },
    //创建订单
    async create(type) {
      const param = {};
      param.note = this.ruleForm.note;
      param.address1 = this.ruleForm.address;
      param.address2 = this.ruleForm.address2;
      param.city = this.ruleForm.city;
      param.countryId = this.countryId;
      param.email = this.ruleForm.email;
      param.firstName = this.ruleForm.firstName;
      param.lastName = this.ruleForm.lastName;
      param.logsiticsType = this.value;
      param.phone = this.ruleForm.phone;
      param.province = this.ruleForm.state;
      param.zipCode = this.ruleForm.zipCode;
      param.lastName = this.ruleForm.lastName;
      param.itemList = this.variantsIdList;
      param.isSample = this.isSamples;
      param.zipCode = this.ruleForm.postal;
      let { data } = await createOrder(param);
      //创建样品，不需要支付
      if (type == 1) {
        //把创建订单弹框关闭
        this.$parent.isOrder = false;
        this.isShowCreateOrder = false;
        this.$parent.isOnePay2 = false;
        this.pullList();
      } else {
        this.orderId.push(data.orderId);
        //创建订单页面关闭
        this.isShowCreateOrder = false;
        // //把创建订单弹框关闭
        // this.$parent.isOrder = true;
        //弹出支付的界面
        this.outerVisible = true;
      }
    },
    //数字文本框
    onChange(e, index, item) {
      this.createProductList[index]["changePrice"] =
        (this.createProductList[index]["retailPrice"] * 100 * (e * 100)) /
        10000;
      for (let i = 0; i < this.variantsIdList.length; i++) {
        if (item.variantId == this.variantsIdList[i].variantId) {
          this.variantsIdList[i].num = e;
        }
      }
      console.log(this.variantsIdList);
    },
    //下一步
    next(val) {
      if (val == 2) {
        if (this.createProductList.length > 0) {
          this.isDisableTab2 = false;
          this.activeKey = val;
        }
      }
    },
    retrunFirst() {
      this.mask = false;
      this.addProduct = true;
    },
    addProduct_fun() {
      this.breadcrumb = {
        name1: "",
        name2: "",
        name3: "",
      };
      this.mask = true;
      this.choiceProduct = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisableTab3 = false;
          this.activeKey = 3;
          this.calculatePrice();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    back(val) {
      this.activeKey = val - 1;
    },
    //查询是否已经绑卡
    async queryPayMsg() {
      let { data } = await payMsg();
      this.payInfo = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.scrolly {
  overflow-y: scroll;
}
.order-mask {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 10;
  overflow-y: scroll;
  .order-msg {
    display: flex;
    margin: 0 30px;
    margin-top: 30px;
    .o-list {
      flex: 1;
      .o-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 19px;
      }
      p {
        margin: 0;
        font-size: 16px;
      }
      .o-total {
        font-size: 16px;
        height: 23px;
        margin-bottom: 8px;
        span {
          float: left;
          font-weight: bold;
        }
        em {
          font-weight: bold;
          font-style: normal;
          float: right;
        }
      }
      .o-price {
        font-size: 13px;
        height: 23px;
        margin-bottom: 8px;
        em {
          font-style: normal;
          float: right;
        }
      }
      .o-totalprice {
        border-top: 1px solid #ebebeb;
        span {
          font-size: 16px;
          font-weight: bold;
          padding-top: 12px;
          display: block;
          float: left;
        }
        em {
          font-size: 16px;
          font-style: normal;
          font-weight: bold;
          float: right;
          padding-top: 12px;
          display: block;
        }
      }
    }
  }
  .o-btn {
    margin: 0 30px;
    margin-top: 20px;
    text-align: right;
    padding-bottom: 20px;
    display: flex;
    button {
      margin-left: 24px;
      font-weight: bold;
    }
    div {
      margin-left: auto;
    }
  }
  .first {
    height: 363px;
    .total-price {
      margin-top: 20px;
      text-align: right;
      position: absolute;
      bottom: 70px;
      right: 30px;
      em {
        margin-right: 28px;
        margin-left: 39px;
        font-style: normal;
        font-size: 18px;
        font-weight: 600;
      }
      span {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .continue {
      text-align: right;
      margin-top: 20px;
      position: absolute;
      bottom: 20px;
      right: 30px;
      button {
        margin-right: 20px;
      }
    }
    .add {
      display: flex;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.04);
      width: 100%;
      padding: 10px 20px;
      cursor: pointer;
      border-radius: 3px;
      color: rgba(0, 0, 0, 0.42);
      margin: 0 30px;
      span {
        margin-left: 20px;
      }
    }
    .me {
      position: absolute;
      top: 0;
      left: 0px;
      right: 0px;
      bottom: 0;
      height: 400px;
      background-color: rgba(255, 255, 255, 0.5);
      .search {
        box-shadow: 0 0 10px #ddd;
        height: 56px;
        padding-left: 18px;
        border-radius: 3px;
        background-color: white;
        display: flex;
        margin: 0 30px;
        margin-top: 60px;
        i {
          font-size: 21px;
          line-height: 56px;
          margin-right: 15px;
        }
        input {
          padding-left: 15px;
          height: 54px;
          flex: 1;
        }
        input:focus {
          outline: none;
        } /*  focus 标记*/
      }
      .products {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
          0 6px 12px 0 rgba(0, 0, 0, 0.04);
        display: block;
        height: 298px;
        background: white;
        margin-top: 2px;
        margin: 0 30px;
        overflow: hidden;
        overflow-y: scroll;
        .titles {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.42);
          margin-right: 10px;
          margin-top: 15px;
          margin-left: 15px;
          margin-bottom: 15px;
        }
        .p-list {
          display: flex;
          align-items: center;
          min-height: 96px;
          padding: 15px;
          cursor: pointer;
          &:hover {
            background-color: #f7f7f7;
          }
          .p-left {
            width: 64px;
            height: 64px;
            border: 1px solid rgba(0, 0, 0, 0.04);
            flex-shrink: 0;
            img {
              width: 62px;
              height: 62px;
            }
          }
          .p-right {
            flex: 1;
            margin-left: 20px;
            h1 {
              margin-bottom: 6px;
              font-weight: 500;
              font-size: 16px;
            }
            p {
              font-size: 13px;
              color: rgba(0, 0, 0, 0.42);
              margin: 0;
            }
          }
          .p-icon {
            margin-right: 0;
          }
        }
      }
      .sku {
        box-shadow: 0 7px 10px #ddd;
        display: inline-block;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        height: 298px;
        overflow: hidden;
        overflow-y: scroll;
        background: white;
        margin-top: 2px;
        .bread {
          margin-top: 15px;
          margin-bottom: 15px;
        }
        .sku-list {
          width: 100%;
          display: flex;
          padding: 10px 10px;
          cursor: pointer;
          align-items: center;
          &:hover {
            background-color: #f7f7f7;
          }
          .s-img {
            width: 62px;
            height: 62px;
            border: 1px solid rgba(0, 0, 0, 0.04);
            img {
              width: 60px;
              height: 60px;
            }
          }
          .isAdd {
            font-size: 16px;
            flex: 1;
            span {
              padding-left: 20px;
            }
          }
          .s-name {
            flex: 3;
            font-size: 13px;
            line-height: 62px;
            margin-left: 15px;
          }
          .s-price {
            font-size: 16px;
            line-height: 62px;
          }
        }
      }
    }
  }
}
.c-content {
  position: absolute;
  top: 80px;
  left: 10%;
  right: 10%;
  background-color: white;
  margin: 0 auto;
  .close {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #333;
    cursor: pointer;
  }
  .title {
    font-size: 16px;
    margin-top: 20px;
    margin-left: 15px;
    font-weight: bold;
  }
}
.add-product {
  margin-top: 15px;
  background: white;
  height: 208px;
  overflow-y: scroll;
  .a-list {
    display: flex;
    padding: 15px 30px;
    align-items: center;
    &:hover {
      background-color: #f7f7f7;
    }
    .a-img {
      width: 62px;
      height: 62px;
      border: 1px solid rgba(0, 0, 0, 0.04);
      img {
        width: 60px;
        height: 60px;
      }
    }
    .a-msg {
      margin-left: 15px;
      flex: 8;
      h1 {
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 16px;
      }
      p {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.42);
        margin: 0;
      }
    }
    .a-num {
      flex: 1;
    }
    .a-price {
      font-size: 16px;
      line-height: 62px;
      flex: 1;
    }
    .a-price2 {
      font-size: 16px;
      line-height: 62px;
      flex: 1;
      text-align: center;
    }
    .a-count {
      flex: 1;
    }
    .a-del {
      width: 24px;
      height: 24px;
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
}
.add-productH {
  margin-top: 15px;
  background: white;
  height: auto;
  overflow-y: auto;
}
</style>
